const NBSP = "\u00a0";

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

export const formatDateHeure = (iso) =>
  iso ? `${formatDate(iso)} à ${new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}` : "—";

export const formatEuros = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 })
    .format(n || 0)
    .replace(/[\u202f\u00a0]/g, NBSP);

export const formatNombre = (n) => new Intl.NumberFormat("fr-FR").format(n || 0).replace(/[\u202f\u00a0]/g, NBSP);

export const formatTaille = (o) => (o > 1048576 ? `${(o / 1048576).toFixed(1).replace(".", ",")} Mo` : `${Math.max(1, Math.round(o / 1024))} Ko`);

export const initiales = (u) => `${u?.prenom?.[0] || ""}${u?.nom?.[0] || ""}`.toUpperCase();
